export const messages = {
  en: {
    refundPrePayFee: {
      title: 'Refund Prepaid Receipt',
      orderNo: 'Order No:',
      orderType: 'Order Type:',
      paymentOrder: 'Payment Order',
      prepaidOrder: 'Prepaid Order',
      payer: 'Payer:',
      owner: 'Owner:',
      feeItems: 'Fee Items',
      feeName: 'Fee Name',
      paymentPeriod: 'Payment Period',
      actualAmount: 'Actual Amount',
      refundReason: 'Refund Reason',
      refundReasonPlaceholder: 'Please enter refund reason',
      submitRefund: 'Submit Refund Application',
      reasonRequired: 'Refund reason cannot be empty',
      reasonTooLong: 'Refund reason cannot exceed 200 characters',
      selectFeeItems: 'Please select fee items to refund',
      operationSuccess: 'Operation successful',
      operationFailed: 'Operation failed',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    refundPrePayFee: {
      title: '退预付收款',
      orderNo: '订单号:',
      orderType: '订单类型:',
      paymentOrder: '缴费单',
      prepaidOrder: '预存单',
      payer: '收费对象:',
      owner: '业主:',
      feeItems: '费用项',
      feeName: '费用项',
      paymentPeriod: '缴费时间段',
      actualAmount: '实收金额',
      refundReason: '退费原因',
      refundReasonPlaceholder: '请输入退费原因',
      submitRefund: '提交退费申请',
      reasonRequired: '退费原因不能为空',
      reasonTooLong: '退费原因不能超过200位',
      selectFeeItems: '请选择需要退费的费用项',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
      fetchError: '获取数据失败'
}
  },
  'zh-TW': {
    refundPrePayFee: {
      title: '退預付收款',
      orderNo: '訂單號:',
      orderType: '訂單類型:',
      paymentOrder: '繳費單',
      prepaidOrder: '預存單',
      payer: '收費對象:',
      owner: '業主:',
      feeItems: '費用項',
      feeName: '費用項',
      paymentPeriod: '繳費時間段',
      actualAmount: '實收金額',
      refundReason: '退費原因',
      refundReasonPlaceholder: '請輸入退費原因',
      submitRefund: '提交退費申請',
      reasonRequired: '退費原因不能為空',
      reasonTooLong: '退費原因不能超過200位',
      selectFeeItems: '請選擇需要退費的費用項',
      operationSuccess: '操作成功',
      operationFailed: '操作失敗',
      fetchError: '獲取數據失敗'
    }
  }
}